import { parseBrazilianDate } from "@/lib/date-utils";
import type { NewsApiResponse, NewsItem } from "@/types/news";

const NEWS_API_URL =
	"https://db-cnews-default-rtdb.firebaseio.com/public_data/news.json";

export const fetchNews = async (): Promise<NewsItem[]> => {
	const response = await fetch(NEWS_API_URL);

	if (!response.ok) {
		throw new Error("Falha ao carregar notícias");
	}

	const data: NewsApiResponse = await response.json();

	if (!data) {
		return [];
	}

	// Convert object to array with IDs
	const newsArray: NewsItem[] = Object.entries(data).map(([id, news]) => ({
		id,
		...news,
	}));

	// Sort by date (newest first)
	return newsArray.sort((a, b) => {
		const dateA = parseBrazilianDate(a.newsDate)?.getTime() ?? 0;
		const dateB = parseBrazilianDate(b.newsDate)?.getTime() ?? 0;

		return dateB - dateA;
	});
};

export const getNewsById = async (id: string): Promise<NewsItem | null> => {
	const news = await fetchNews();
	return news.find((item) => item.id === id) || null;
};
